module.exports = __webpack_public_path__ + "static/media/climbing.74ffef87.jpg";